export class PopoverItemStyle {
  background = 'uk-card-default';
  position = 'top-center';
  padding = 'uk-padding-small';
}
